import React from "react";
import { useTranslation } from "react-i18next";
import FeedbackModal from "../feedback/FeedbackModal";

const NoSerialNumberAlert = ({ show, onHide, confirmDescription }) => {
  const { t } = useTranslation();

  return (
    <FeedbackModal
      show={show}
      onHide={onHide}
      severity="warning"
      title={t("message.confirm.noSerialNumber")}
      message={
        confirmDescription
          ? t(confirmDescription)
          : t("Serial Number is required")
      }
    />
  );
};

export default NoSerialNumberAlert;
